/*!
 * Halloween Diagonal Spider Web — realistic web version
 */
(function () {
  var cfg = window.HALLOWEEN_SPIDER_WEB || {};
  var DURATION = cfg.durationMs != null ? cfg.durationMs : 4600;
  var HOLD_MS  = cfg.holdMs != null ? cfg.holdMs : 900;
  var FADE_MS  = cfg.fadeMs != null ? cfg.fadeMs : 900;
  var SIZE_MUL = cfg.size != null ? cfg.size : 1;
  var ONCE = cfg.oncePerSession != null ? cfg.oncePerSession : true;
  var SEEN_KEY = 'hw-spider-diagonal-seen';

  if (window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  try {
    if (ONCE && sessionStorage.getItem(SEEN_KEY) === '1') return;
  } catch (e) {}

  try {
    if (ONCE) sessionStorage.setItem(SEEN_KEY, '1');
  } catch (e) {}

  var rand = function (a, b) {
    return a + Math.random() * (b - a);
  };

  var svgNS = 'http://www.w3.org/2000/svg';

  function run() {

    var wrap = document.createElement('div');

    wrap.setAttribute('aria-hidden', 'true');

    wrap.style.cssText =
      'position:fixed;inset:0;z-index:2147483000;' +
      'pointer-events:none;overflow:hidden;' +
      'opacity:1;transition:opacity ' + FADE_MS + 'ms ease';

    document.body.appendChild(wrap);


    /* =====================================================
       FULLSCREEN SVG
    ===================================================== */

    var svg = document.createElementNS(svgNS, 'svg');

    svg.setAttribute('viewBox', '0 0 100 100');
    svg.setAttribute('preserveAspectRatio', 'none');

    svg.style.cssText =
      'position:fixed;inset:0;width:100%;height:100%';

    wrap.appendChild(svg);


    /* =====================================================
       SPIDER MOVEMENT PATH
    ===================================================== */

    var startX = -8;
    var startY = 108;

    var endX = 108;
    var endY = -8;


    function pointAt(t) {

      var x = startX + (endX - startX) * t;
      var y = startY + (endY - startY) * t;

      var wob =
        Math.sin(t * Math.PI * 3.1) *
        6 *
        (1 - Math.abs(t - 0.5) * 1.1);

      x += wob * 0.4;
      y -= wob * 0.5;

      return {
        x: x,
        y: y
      };
    }


    var lastWebT = 0;


    /* =====================================================
       SILK GLINT
    ===================================================== */

    function glint(x, y, delay) {

      var s = document.createElement('span');

      s.style.cssText =
        'position:absolute;' +
        'left:' + x + '%;' +
        'top:' + y + '%;' +
        'width:3px;' +
        'height:3px;' +
        'border-radius:50%;' +
        'background:radial-gradient(circle,#000,rgba(0,0,0,0) 70%);' +
        'opacity:0;' +
        'transform:translate(-50%,-50%)';

      wrap.appendChild(s);

      s.style.transition = 'opacity .5s ease';

      setTimeout(function () {
        s.style.opacity = '.7';
      }, delay);

      setTimeout(function () {

        s.style.opacity = '0';

        setTimeout(function () {

          if (s.parentNode) {
            s.parentNode.removeChild(s);
          }

        }, 600);

      }, delay + 700 + rand(0, 500));
    }


    /* =====================================================
       REALISTIC SILK PATH
    ===================================================== */

    function silkPath(points, opacity, width, duration, delay) {

      if (!points || points.length < 2) return null;

      var d =
        'M' +
        points[0].x.toFixed(2) +
        ' ' +
        points[0].y.toFixed(2);


      for (var i = 1; i < points.length; i++) {

        var prev = points[i - 1];
        var p = points[i];

        var cx =
          (prev.x + p.x) / 2 +
          rand(-0.8, 0.8);

        var cy =
          (prev.y + p.y) / 2 +
          rand(-0.8, 0.8);

        d +=
          ' Q' +
          cx.toFixed(2) +
          ' ' +
          cy.toFixed(2) +
          ' ' +
          p.x.toFixed(2) +
          ' ' +
          p.y.toFixed(2);
      }


      var path =
        document.createElementNS(svgNS, 'path');

      path.setAttribute('d', d);

      path.setAttribute(
  'stroke',
  'rgba(0,0,0,' + opacity + ')'
);

      path.setAttribute(
        'stroke-width',
        width
      );

      path.setAttribute('fill', 'none');

      path.setAttribute(
        'stroke-linecap',
        'round'
      );

      path.setAttribute(
        'stroke-linejoin',
        'round'
      );

      path.setAttribute(
        'pathLength',
        '1'
      );

      path.style.strokeDasharray = '1';
      path.style.strokeDashoffset = '1';

      svg.appendChild(path);


      if (path.animate) {

        path.animate(
          [
            {
              strokeDashoffset: 1
            },
            {
              strokeDashoffset: 0
            }
          ],
          {
            duration: duration || 650,
            delay: delay || 0,
            easing: 'cubic-bezier(.2,.7,.2,1)',
            fill: 'forwards'
          }
        );

      } else {

        setTimeout(function () {

          path.style.strokeDashoffset = '0';

        }, delay || 0);

      }


      return path;
    }


    /* =====================================================
       REAL ORB SPIDER WEB
    ===================================================== */

    function buildRealWeb(cx, cy, scale) {

      var spokes = 17;
      var rings = 7;


      /*
       * RADIAL SUPPORT THREADS
       */

      for (var s = 0; s < spokes; s++) {

        var angle =
          (Math.PI * 2 * s / spokes) +
          rand(-0.055, 0.055);

        var maxR =
          scale * rand(.86, 1.12);

        var points = [
          {
            x: cx,
            y: cy
          }
        ];


        for (var r = 1; r <= rings; r++) {

          var rr =
            maxR * (r / rings);

          var drift =
            rand(
              -scale * .035,
              scale * .035
            );


          var px =
            cx +
            Math.cos(angle) *
            (rr + drift);

          var py =
            cy +
            Math.sin(angle) *
            (rr + drift);


          points.push({
            x: px,
            y: py
          });
        }


        silkPath(
          points,
          s % 3 === 0 ? '.50' : '.34',
          s % 4 === 0 ? '.15' : '.11',
          600 + s * 18,
          s * 18
        );
      }


      /*
       * CONCENTRIC CAPTURE SPIRAL
       */

      for (var ring = 1; ring <= rings; ring++) {

        var ringPoints = [];

        var radiusRatio =
          ring / rings;


        for (
          var j = 0;
          j <= spokes + 1;
          j++
        ) {

          var a =
            (Math.PI * 2 * j / spokes) +
            .10;


          var baseR =
            scale * radiusRatio;


          var variation =
            Math.sin(
              j * 1.7 +
              ring * .9
            ) *
            scale *
            .025
            +
            rand(
              -scale * .018,
              scale * .018
            );


          ringPoints.push({

            x:
              cx +
              Math.cos(a) *
              (baseR + variation),

            y:
              cy +
              Math.sin(a) *
              (baseR + variation)

          });
        }


        silkPath(

          ringPoints,

          ring === 1
            ? '.55'
            : (ring % 2 ? '.38' : '.31'),

          ring === 1
            ? '.14'
            : '.105',

          900 + ring * 110,

          80 + ring * 45
        );
      }


      /*
       * BROKEN OUTER SILK
       */

      for (var loose = 0; loose < 7; loose++) {

        var la =
          rand(0, Math.PI * 2);

        var lr =
          scale * rand(.82, 1.22);


        var p1 = {

          x:
            cx +
            Math.cos(la) *
            lr,

          y:
            cy +
            Math.sin(la) *
            lr

        };


        var p2 = {

          x:
            p1.x +
            rand(
              -scale * .20,
              scale * .20
            ),

          y:
            p1.y +
            rand(
              -scale * .20,
              scale * .20
            )

        };


        silkPath(

          [
            p1,

            {
              x:
                (p1.x + p2.x) / 2 +
                rand(-2, 2),

              y:
                (p1.y + p2.y) / 2 +
                rand(-2, 2)
            },

            p2
          ],

          '.22',
          '.08',
          500,
          rand(100, 450)
        );
      }


      /*
       * WET SILK HIGHLIGHTS
       */

      for (var g = 0; g < 14; g++) {

        var ga =
          rand(0, Math.PI * 2);

        var gr =
          scale * rand(.15, 1.02);


        glint(

          cx +
          Math.cos(ga) *
          gr,

          cy +
          Math.sin(ga) *
          gr,

          rand(250, 1200)

        );
      }
    }


    /* =====================================================
       SPIDER
    ===================================================== */

    var legDefs = [

      {
        ox: -5,
        oy: -4,
        kx: -20,
        ky: -16,
        ex: -33,
        ey: -5
      },

      {
        ox: -6,
        oy: 0,
        kx: -22,
        ky: 6,
        ex: -33,
        ey: 16
      },

      {
        ox: -5,
        oy: 4,
        kx: -18,
        ky: 16,
        ex: -27,
        ey: 29
      },

      {
        ox: -2,
        oy: 7,
        kx: -9,
        ky: 20,
        ex: -11,
        ey: 33
      }

    ];


    function buildSpiderSVG() {

      var legsHtml = '';


      legDefs.forEach(function (L, idx) {

        [1, -1].forEach(function (mirror) {

          var grp =
            (idx % 2 === 0)
              ? 'A'
              : 'B';


          var ox = L.ox * mirror;
          var oy = L.oy;

          var kx = L.kx * mirror;
          var ky = L.ky;

          var ex = L.ex * mirror;
          var ey = L.ey;


          var hairs = '';


          for (
            var h = 1;
            h <= 3;
            h++
          ) {

            var ht = h / 4;


            var hx =
              ox +
              (kx - ox) *
              ht;

            var hy =
              oy +
              (ky - oy) *
              ht;


            var hx2 =
              kx +
              (ex - kx) *
              (ht - 0.1);

            var hy2 =
              ky +
              (ey - ky) *
              (ht - 0.1);


            hairs +=
              '<line ' +
              'x1="' + hx + '" ' +
              'y1="' + hy + '" ' +
              'x2="' +
              (hx + mirror * 2.4) +
              '" ' +
              'y2="' +
              (hy - 1.6) +
              '" ' +
              'stroke="#09070a" ' +
              'stroke-width="0.72" ' +
              'opacity=".62"/>' ;


            if (ht > 0.3) {

              hairs +=
                '<line ' +
                'x1="' + hx2 + '" ' +
                'y1="' + hy2 + '" ' +
                'x2="' +
                (hx2 + mirror * 2) +
                '" ' +
                'y2="' +
                (hy2 - 1.4) +
                '" ' +
                'stroke="#09070a" ' +
                'stroke-width="0.65" ' +
                'opacity=".58"/>';
            }

          }


          legsHtml +=

            '<g ' +
            'class="hsw-hip" ' +
            'data-grp="' + grp + '" ' +
            'data-i="' + idx + '" ' +
            'data-m="' + mirror + '" ' +
            'data-ph="' +
            rand(0,0.12).toFixed(3) +
            '" ' +
            'style="transform-origin:' +
            ox + 'px ' +
            oy + 'px">' +


            '<path ' +
            'class="hsw-leg" ' +
            'd="M' +
            ox + ' ' +
            oy +
            ' Q' +
            (kx * 0.6) +
            ' ' +
            (ky * 0.5) +
            ' ' +
            kx +
            ' ' +
            ky +
            ' Q' +
            (kx + (ex-kx)*0.4) +
            ' ' +
            (ky + (ey-ky)*0.3) +
            ' ' +
            ex +
            ' ' +
            ey +
            '" ' +
            'stroke="url(#hsw-legGrad)" ' +
            'stroke-width="2.15" ' +
            'fill="none" ' +
            'stroke-linecap="round"/>' +


            '<circle ' +
            'cx="' + kx + '" ' +
            'cy="' + ky + '" ' +
            'r="1.5" ' +
            'fill="#1c1420"/>' +

            hairs +

            '</g>';

        });

      });


      return (

        '<svg ' +
        'viewBox="-42 -26 84 60" ' +
        'width="100%" ' +
        'height="100%" ' +
        'style="overflow:visible">' +


        '<defs>' +

        '<linearGradient ' +
        'id="hsw-legGrad" ' +
        'x1="0" ' +
        'y1="0" ' +
        'x2="1" ' +
        'y2="1">' +

        '<stop ' +
        'offset="0" ' +
        'stop-color="#181818"/>' +

        '<stop ' +
        'offset="100%" ' +
        'stop-color="#020202"/>' +

        '</linearGradient>' +


        '<radialGradient ' +
        'id="hsw-bodyGrad" ' +
        'cx="38%" ' +
        'cy="30%" ' +
        'r="70%">' +

        '<stop ' +
'offset="0" ' +
'stop-color="#252525"/>' +

'<stop ' +
'offset="45%" ' +
'stop-color="#111111"/>' +

'<stop ' +
'offset="100%" ' +
'stop-color="#030303"/>' +

        '</radialGradient>' +


        '<radialGradient ' +
        'id="hsw-headGrad" ' +
        'cx="40%" ' +
        'cy="30%" ' +
        'r="70%">' +

        '<stop ' +
        'offset="0" ' +
        'stop-color="#202020"/>' +

        '<stop ' +
        'offset="100%" ' +
        'stop-color="#020202"/>' +

        '</radialGradient>' +

        '</defs>' +


        legsHtml +


        '<ellipse ' +
        'cx="2" ' +
        'cy="19" ' +
        'rx="10" ' +
        'ry="6.5" ' +
        'fill="rgba(0,0,0,.35)" ' +
        'style="filter:blur(2px)"/>' +


        '<g id="hsw-torso">' +

        '<ellipse ' +
        'cx="0" ' +
        'cy="11" ' +
        'rx="12" ' +
        'ry="9" ' +
        'fill="url(#hsw-bodyGrad)"/>' +


        '<ellipse ' +
        'cx="-3.2" ' +
        'cy="8.4" ' +
        'rx="4.8" ' +
        'ry="3.1" ' +
        'fill="#333333" ' +
        'opacity=".18"/>' +


        '<ellipse ' +
        'cx="4.2" ' +
        'cy="13.2" ' +
        'rx="4.5" ' +
        'ry="2.8" ' +
        'fill="#080607" ' +
        'opacity=".20"/>' +


        '<path ' +
        'd="M-7 6 Q0 13 7 6" ' +
        'stroke="#1c130e" ' +
        'stroke-width="1.4" ' +
        'fill="none" ' +
        'opacity=".55"/>' +


        '<ellipse ' +
        'cx="-3" ' +
        'cy="8" ' +
        'rx="2.6" ' +
        'ry="1.6" ' +
        'fill="#1c130e" ' +
        'opacity=".5"/>' +


        '<ellipse ' +
        'cx="4" ' +
        'cy="13" ' +
        'rx="3" ' +
        'ry="1.8" ' +
        'fill="#1c130e" ' +
        'opacity=".4"/>' +


        '<ellipse ' +
        'cx="-3.5" ' +
        'cy="7" ' +
        'rx="3" ' +
        'ry="2" ' +
        'fill="#222222" ' +
        'opacity=".35"/>' +


        '<circle ' +
        'cx="0" ' +
        'cy="-2" ' +
        'r="6" ' +
        'fill="url(#hsw-headGrad)"/>' +


        '<circle ' +
        'cx="-2.4" ' +
        'cy="-3.6" ' +
        'r="1.15" ' +
        'fill="#120c0f"/>' +

        '<circle ' +
        'cx="2.4" ' +
        'cy="-3.6" ' +
        'r="1.15" ' +
        'fill="#120c0f"/>' +


        '<circle ' +
        'cx="-2.4" ' +
        'cy="-3.6" ' +
        'r=".4" ' +
        'fill="#ff8a3a"/>' +

        '<circle ' +
        'cx="2.4" ' +
        'cy="-3.6" ' +
        'r=".4" ' +
        'fill="#ff8a3a"/>' +


        '<circle ' +
        'cx="-1.1" ' +
        'cy="-1.4" ' +
        'r=".55" ' +
        'fill="#120c0f"/>' +

        '<circle ' +
        'cx="1.1" ' +
        'cy="-1.4" ' +
        'r=".55" ' +
        'fill="#120c0f"/>' +


        '<circle ' +
        'cx="-0.3" ' +
        'cy="-5.2" ' +
        'r=".4" ' +
        'fill="#120c0f"/>' +

        '<circle ' +
        'cx="0.3" ' +
        'cy="-5.2" ' +
        'r=".4" ' +
        'fill="#120c0f"/>' +

        '</g>' +

        '</svg>'
      );
    }


    /* =====================================================
       SPIDER CONTAINER
    ===================================================== */

    /* CLS fix 2026-10-28: the spider is drawn inside a full-screen SVG layer and moved with an SVG transform.
       Before, it was a <div> moved with left/top on every frame, and Google counted every frame as a layout
       shift (CLS) on the first page of each visit. Shapes moving inside an SVG are not layout shifts.
       Same size, position, rotation, shadow and fade as before. */

    var boxSize =
      Math.min(
        340,
        Math.max(
          90,
          window.innerWidth * 0.11
        )
      ) *
      SIZE_MUL;


    var spiderLayer =
      document.createElementNS(svgNS, 'svg');

    spiderLayer.setAttribute('width', '100%');
    spiderLayer.setAttribute('height', '100%');

    spiderLayer.style.cssText =
      'position:fixed;inset:0;width:100%;height:100%;overflow:visible';


    var spiderBox =
      document.createElementNS(svgNS, 'g');

    spiderBox.style.opacity = '0';

    spiderBox.setAttribute(
      'transform',
      'translate(0 ' + document.documentElement.clientHeight + ')'
    );


    /* same shadow as the old CSS drop-shadow(0 6px 10px rgba(0,0,0,.38)), turning with the spider */
    spiderBox.innerHTML =
      '<defs>' +
      '<filter id="hsw-shadow" x="-50%" y="-50%" width="200%" height="200%">' +
      '<feDropShadow dx="0" dy="6" stdDeviation="5" flood-color="#000" flood-opacity=".38"/>' +
      '</filter>' +
      '</defs>' +
      '<g filter="url(#hsw-shadow)">' +
      buildSpiderSVG().replace(
        'width="100%" height="100%"',
        'x="' + (-boxSize / 2) + '" y="' + (-boxSize / 2) + '" ' +
        'width="' + boxSize + '" height="' + boxSize + '"'
      ) +
      '</g>';


    spiderLayer.appendChild(spiderBox);

    wrap.appendChild(spiderLayer);


    requestAnimationFrame(function () {

      spiderBox.style.transition =
        'opacity .3s ease';

      spiderBox.style.opacity = '1';

    });


    var hipEls =
      spiderBox.querySelectorAll('.hsw-hip');

    var torso =
      spiderBox.querySelector('#hsw-torso');


    var t0 =
      performance.now();


    var raf = 0;
    var lastSample = -1;


    /* =====================================================
       WALKING ANIMATION
    ===================================================== */

    var STRIDE_HZ_BASE = 1.55;


    function strideSpeedAt(tSec) {

      return STRIDE_HZ_BASE *
        (
          1 +
          Math.sin(tSec * 0.7) * 0.08 +
          Math.sin(tSec * 2.3) * 0.04
        );
    }


    var cyclePos = 0;
    var lastT = t0;


    function easeInOut(x) {

      return x < 0.5

        ? 2 * x * x

        : 1 -
          Math.pow(
            -2 * x + 2,
            2
          ) / 2;
    }


    function frame(now) {

      var t =
        Math.min(
          1,
          (now - t0) /
          DURATION
        );


      var pos =
        pointAt(t);


      /*
       * BUILD REAL WEB BEHIND SPIDER
       */

      if (
        t - lastWebT >= 0.16 &&
        t < 0.96
      ) {

        lastWebT = t;

        buildRealWeb(
          pos.x,
          pos.y,
          rand(7.5, 11.5)
        );
      }


      /*
       * MOVE SPIDER
       */

      /* CLS fix 2026-10-28: same spot as the old left: pos.x% / top: pos.y% of the screen */
      var moveX =
        pos.x * document.documentElement.clientWidth / 100;

      var moveY =
        pos.y * document.documentElement.clientHeight / 100;


      var ahead =
        pointAt(
          Math.min(
            1,
            t + 0.01
          )
        );


      var angle =
        Math.atan2(
          ahead.y - pos.y,
          ahead.x - pos.x
        ) *
        180 /
        Math.PI;


      /*
       * WALK CYCLE
       */

      var dtSec =
        (now - lastT) /
        1000;

      lastT = now;


      cyclePos +=
        dtSec *
        strideSpeedAt(
          now / 1000
        );


      var cycle =
        cyclePos % 1;


      hipEls.forEach(
        function (hip) {

          var grp =
            hip.getAttribute(
              'data-grp'
            );


          var ownPhase =
            parseFloat(
              hip.getAttribute(
                'data-ph'
              )
            ) || 0;


          var base =
            grp === 'A'
              ? cycle
              : (cycle + 0.5) % 1;


          var phase =
            (base + ownPhase) % 1;


          var swingAmt;
          var lift;
          var stretch;


          if (phase < 0.5) {

            var sp =
              easeInOut(
                phase / 0.5
              );


            swingAmt =
              15 -
              sp * 30;


            lift = 0;
            stretch = 1;

          } else {

            var wp =
              easeInOut(
                (phase - 0.5) /
                0.5
              );


            swingAmt =
              -15 +
              wp * 30;


            lift =
              Math.sin(
                wp * Math.PI
              ) *
              5.5;


            stretch =
              1 -
              Math.sin(
                wp * Math.PI
              ) *
              0.16;
          }


          hip.style.transform =

            'rotate(' +
            swingAmt.toFixed(1) +
            'deg) ' +

            'translateY(' +
            (-lift).toFixed(1) +
            'px) ' +

            'scale(' +
            stretch.toFixed(3) +
            ')';

        }
      );


      /*
       * BODY MOVEMENT
       */

      var bodyBob =
        Math.sin(
          cyclePos *
          Math.PI *
          2
        ) *
        0.45;


      var sway =
        Math.sin(
          cyclePos *
          Math.PI *
          2 +
          1.2
        ) *
        0.8
        +
        Math.sin(
          now / 900
        ) *
        0.3;


      spiderBox.setAttribute(
        'transform',
        'translate(' +
        moveX.toFixed(2) +
        ' ' +
        moveY.toFixed(2) +
        ') ' +
        'rotate(' +
        (angle + 90).toFixed(1) +
        ')'
      );


      if (torso) {

        torso.style.transform =
          'translate(' +
          sway.toFixed(2) +
          'px,' +
          bodyBob.toFixed(2) +
          'px)';
      }


      if (t < 1) {

        raf =
          requestAnimationFrame(
            frame
          );

      } else {

        finishWalk();
      }

    }


    /* =====================================================
       FINISH
    ===================================================== */

    function finishWalk() {

      spiderBox.style.transition =
        'opacity .25s ease';

      spiderBox.style.opacity = '0';


      setTimeout(
        function () {

          wrap.style.opacity = '0';


          setTimeout(
            function () {

              if (wrap.parentNode) {

                wrap.parentNode
                  .removeChild(wrap);

              }

            },
            FADE_MS + 60
          );

        },
        HOLD_MS
      );
    }


    raf =
      requestAnimationFrame(
        frame
      );


    /*
     * PAUSE WHEN TAB IS HIDDEN
     */

    document.addEventListener(
      'visibilitychange',
      function () {

        if (document.hidden) {

          cancelAnimationFrame(raf);

        } else {

          lastT =
            performance.now();

          raf =
            requestAnimationFrame(
              frame
            );
        }

      }
    );

  }


  if (document.body) {

    run();

  } else {

    document.addEventListener(
      'DOMContentLoaded',
      run
    );
  }

})();